/**  
 * created by hezq on 2019-08-29
 * 
 * description： 弹出窗插件
 * 
 */

export default class Dialog {
	/**
	 * description： 构造函数
	 * @param {Object} 属性集合
	 *
	 * created by hezq on 2019-08-29
	 *
	 */
	constructor(arg) {
		arg = arg || {};
		// 弹出窗唯一标识
		this.pkid = arg.pkid || new Date().getTime();
		// 弹出窗id
		this.id = 'dialog_' + this.pkid;
		// 弹出窗内容区域id
		this.contentId = 'dialog_content_' + this.pkid;
		// 弹出窗内容区域class
		this.contentClass = arg.class || '';
		// 弹出窗的层级
		this.zIndex = arg.zIndex || 1000;
		// 弹出窗标题
		this.title = arg.title || '';
		// 弹出窗是否可以通过点击遮罩层关闭
		this.closeOnClick = arg.closeOnClick !== false; 
		// 弹出框宽度
		this.speCss = arg.speCss || '';
		this.speCss1 = arg.speCss1 || '';
		// 关闭弹窗执行函数
		this.closeFn = arg.closeFn || null;
		// 弹出窗html模版
		this.template = `<div class="Messagebox spzx_popule spzx_scoreInfobox bfff spzx_evalmoduel_popule" id="${this.id}" style="z-index:${this.zIndex}; max-height:${window.document.body.offsetHeight}px; overflow-y: auto; display: none;"><h5><span class="dialog_title">${this.title}</span><i class="iconfont spzx-icon-close closeIcon"></i></h5><div id="${this.contentId}" class="${this.contentClass}">${arg.contentHTML}</div></div>`;
		// 渲染弹出窗
		this.render();
	}
	
	/**
	 * description： 弹出窗渲染
	 *
	 * created by hezq on 2019-08-29
	 *
	 */
	render(){
		// 判断弹窗是否已经添加
		if($(`#${this.id}`).length < 1) {
			// 渲染遮罩层
			let mask_html = `<div class="spzx_mask" style="display:none;z-index:${this.zIndex-1}" id="mask_${this.pkid}"></div>`;

			$('body').append(mask_html);

			let self = this;

			// 解绑点击
			$('body').off('click', '#mask_'+ this.pkid);
			$('body').off('click','#'+ this.id + ' .closeIcon');

			// 如果可以通过遮罩关闭弹出窗
			if(this.closeOnClick){
				// 给遮罩层绑定关闭弹出窗事件
				$('body').on('click','#mask_'+ this.pkid,function(){
					self.close();
				});
			}

			// 给关闭图标添加事件
			$('body').on('click','#'+ this.id + ' .closeIcon', function(){
				self.close();
			});

			// 渲染弹出窗
			$('body').append(this.template);
			if(this.speCss.length > 0){
				$(`#${this.id}`).removeClass('spzx_popule');
				$(`#${this.id}`).addClass(this.speCss);
				$(`#${this.id}`).removeClass('spzx_evalmoduel_popule');
				$(`#${this.id}`).addClass(this.speCss1);
				
				// $('.spzx_normSetter ol li').css('width', '180px');
			}
		}
	}
	
	/**
	 * description： 更新弹窗内容
	 *
	 * created by panjm on 2019-08-29
	 *
	 */
	update(html){
		// 更新弹窗内容
		$('#' + this.contentId).html(html);
	}
	
	/**
	 * description： 打开弹出窗
	 *
	 * created by hezq on 2019-08-29
	 *
	 */
	open(){
		// 先重置弹窗
		this.reset();
		
		let dialogEL = $('#dialog_' + this.pkid);
		
		if(dialogEL.size() === 0){
			return;
		}
		
		dialogEL.show();
		
		let maskEL = $('#mask_' + this.pkid);
		
		if(maskEL.size() === 0){
			return;
		}
		
		maskEL.show();
		
		// 打开弹窗时禁止父页面滚动
		$('body').css('overflow', 'hidden');
	}
	
	/**
	 * description： 关闭弹出窗
	 *
	 * created by hezq on 2019-08-29
	 *
	 */
	close(){
		if(this.closeFn) {
			this.closeFn();
		}
		let dialogEL = $('#dialog_' + this.pkid);
		
		if(dialogEL.size() === 0){
			return;
		}
		
		dialogEL.hide();
		
		let maskEL = $('#mask_' + this.pkid);
		
		if(maskEL.size() === 0){
			return;
		}
		
		maskEL.hide();
		
		// 关闭弹窗时恢复父页面滚动
		$('body').css('overflow', 'visible');
	}

	/**
   * description: 重置弹窗
	 * 
   * created by zhouzt on 2019-08-30 15:12:38
   */
	reset() {
		$(`#${this.id}`).remove();

		this.render();
	}
}



// WEBPACK FOOTER //
// ./src/libs/dialog.js